// @flow
import * as React from "react";
import Utilities from "../../utils/Utilities";
import Cookies from "js-cookie";
import { Menu, MenuDivider, MenuItem, Popover, PopoverInteractionKind, Position, Tooltip, AnchorButton, Icon } from "@blueprintjs/core";
import Goal from '../../assets/Goals.svg';
import TeamGoals from '../../assets/TeamGoals.svg';

export default ({ controller, action, userIsAccountOwner, account, isManager }) => {
  return (
    <Popover
      portalContainer={document.body}
      position={Position.RIGHT}
      boundary="viewport"
      interactionKind={PopoverInteractionKind.HOVER}
      popoverClassName="sidebar-submenu-popover"
      content={
        <Menu className="sidebar-submenu-menu">
          <li className="bp3-menu-header">
            <h6 className="bp3-heading">Goals</h6>
          </li>
          <MenuDivider />
          <MenuItem
            text="My Goals"
            icon={<img src={Goal} alt="Goal Icon" className="sidebar-custom-icon" />}
            onClick={() => {
              Cookies.remove("selectedEmployeeId");
              Cookies.remove("selectedEmployeeName");
              Cookies.remove("selectedEmplyeeAccountOwner");

              Utilities.navigate("/goals");
            }}
          />
          {isManager &&
            <MenuItem
              text="Team Goals"
              icon={<img src={TeamGoals} alt="Team Goals Icon" className="sidebar-custom-icon" />}
              href="/goals/tabs"
              onClick={() => Utilities.navigate("/goals/tabs")}
            />}
        </Menu>
      }
    >
      <AnchorButton
        className="bp3-minimal bp3-sidebar-button"
        active={(controller && controller === 'goals' && action !== 'goal_settings') || (action && (action === 'goals' || action === 'goal_view' || action === 'teams_goal'))}
        text="Goals"
        href="/goals"
        onClick={() => Utilities.navigate('/goals')}
        icon={<img src={Goal} alt="Goal Icon" className="sidebar-custom-icon" />}
        rightIcon="chevron-right"
      />
    </Popover>
  );
};
